interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function TwitterIcon(props: Props) {
  const { size = 17, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.862 5.287c.01.138.01.277.01.417 0 4.27-3.302 9.196-9.34 9.196v-.003A9.4 9.4 0 0 1 .5 13.45a6.657 6.657 0 0 0 4.858-1.34 3.28 3.28 0 0 1-3.067-2.244c.492.093 1 .074 1.482-.056C2.242 9.505 1.14 8.18 1.14 6.641v-.04c.457.25.967.388 1.49.404A3.206 3.206 0 0 1 1.614 2.69 9.367 9.367 0 0 0 8.38 6.066a3.202 3.202 0 0 1 .95-3.088 3.323 3.323 0 0 1 4.644.14 6.65 6.65 0 0 0 2.085-.784 3.254 3.254 0 0 1-1.443 1.787 6.61 6.61 0 0 0 1.885-.509 6.613 6.613 0 0 1-1.638 1.675Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}
